import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'
import { Sparkle } from '../../assets/svg'
import { useNavigate } from 'react-router-dom'

const OurServices = () => {
  const navigate = useNavigate();
  return (
    <div className='volto-section our-services'>
        <Container>
            <Row>
                <Col lg={6}>
                  <SectionHeader mainText1="OUR" mainText2="SERVICES" />
                  <SectionSubHeader headerText="Build your Dream" />
                  <SectionSubHeader headerText="Team" />
                  <div className='our-service-image'> <img className='mt-4 img-fluid' src="images/our-services.webp" alt="our-services" /></div>
                </Col>
                <Col lg={6} >
                     <div className='services-list'>
                        <h3  onClick={() => navigate("/services/digital-engineering")}><Sparkle />&nbsp;  Digital Engineering</h3>
                        <h3 onClick={() => navigate("/services/cloud-consulting")}><Sparkle />&nbsp;  Cloud Consulting</h3>
                        <h3 onClick={() => navigate("/services/talent")}><Sparkle />&nbsp;  Talent Enablement</h3>
                        <h3 onClick={() => navigate("/services/ai-engineering")}><Sparkle />&nbsp;  AI & Automation</h3>
                        <h3 onClick={() => navigate("/services/sap-services")}><Sparkle />&nbsp;  SAP Services</h3>
                        <h3 onClick={() => navigate("/services/nearshore")}><Sparkle />&nbsp;  Nearshore Services</h3>
                        <h3  onClick={() => navigate("/services/data-engineering")}><Sparkle />&nbsp;  Data Engineering</h3>
                        <h3 onClick={() => navigate("/services/infrastructure-support")}><Sparkle />&nbsp;  Infrastructure Support</h3>
                        <h3 onClick={() => navigate("/services/training")}><Sparkle />&nbsp;  Training</h3>
                     </div>
                </Col>


            </Row>
        </Container>
      
    </div>
  )
}

export default OurServices
